export default __webpack_public_path__ + "static/media/bf37ee5a589d20c77dbb57229c5fff52.gif";